import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosSecured } from "../../api/axiosClient";
import {
  CREATE_USER,
  DELETE_USER,
  FETCH_USERS,
  GET_CURRENT_USER,
} from "../users/api/users-api";
import { RETRY_DELAY } from "../../utils/constants";

export const USER_QUERIES = {
  fetchUsers: "fetchUsers",
  fetchCurrentUser: "fetchCurrentUser",
};

const useUsersApi = (enabledApis = []) => {
  const {
    data: allUsers = [],
    isLoading: isUsersLoading,
    refetch: fetchUsers,
  } = useQuery({
    queryKey: [USER_QUERIES.fetchUsers],
    queryFn: () => axiosSecured.get(FETCH_USERS).then((res) => res.data.data),
    enabled: enabledApis.includes(USER_QUERIES.fetchUsers),
  });

  const { isPending: isCreateUserLoading, mutateAsync: createUser } =
    useMutation({
      mutationFn: (data) =>
        axiosSecured.post(CREATE_USER, data).then((res) => res.data.data),
    });

  const {
    data: currentUser,
    refetch: fetchCurrentUser,
    isError: isFetchUserError,
  } = useQuery({
    queryKey: [USER_QUERIES.fetchCurrentUser],
    queryFn: () =>
      axiosSecured
        .get(GET_CURRENT_USER)
        .then((res) => res.data.data)
        .catch(console.error),
    enabled: false,
    retry: 3,
    retryDelay: RETRY_DELAY,
  });

  const { mutateAsync: deleteUser, isPending: isDeleteUserLoading } =
    useMutation({
      mutationFn: (id) =>
        axiosSecured.delete(DELETE_USER(id)).then((res) => res.data),
    });

  return {
    getAllUsersApi: {
      get: fetchUsers,
      isLoading: isUsersLoading,
      data: allUsers,
    },
    createUserApi: {
      create: createUser,
      isLoading: isCreateUserLoading,
    },
    getCurrentUserApi: {
      get: fetchCurrentUser,
      data: currentUser,
      error: isFetchUserError,
    },
    deleteUserApi: {
      delete: deleteUser,
      isLoading: isDeleteUserLoading,
    },
  };
};

export default useUsersApi;
